export default {
      id: "reports-icon-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "sprite.svg#reports-icon",
      toString: function () {
        return this.url;
      }
    }